/**
 *
 * CompleteControls
 *
 */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Dropdown, DropdownButton, ProgressBar } from 'react-bootstrap';
import useDialog from 'containers/Dialog/useDialog.js';
import messages from './messages.js';
import getMeetingSteps from '../Planner/getMeetingSteps.js';

const Progress = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 20px;
  color: ${(p) => p.theme.gray};
  font-size: 12px;
  .progress {
    margin: 4px 0 0;
    width: 100%;
    height: 6px;
  }
`;

function CompleteControls(props) {
  const { link, set, overviewLink, onDelete } = props;
  const { meetings, meetingsPlanned } = set;
  const steps = getMeetingSteps(set);

  const { dlgPrompt } = useDialog();
  const intl = useIntl();
  const title = intl.formatMessage(messages.options);
  const values = {
    count: meetingsPlanned,
    total: meetings?.list.length,
  };

  const handleDelete = useCallback(async () => {
    const message = await dlgPrompt({
      title: messages.removeTitle,
      message: { ...messages.removePrompt },
      rows: 3,
    });
    onDelete(message);
  }, [dlgPrompt, onDelete]);

  if (!meetings) {
    return null;
  }

  function getProps(stepId) {
    const step = steps[stepId - 1];
    const disabled = step?.disabled && step.disabled();
    return {
      as: Link,
      eventKey: stepId,
      disabled,
      to: disabled ? undefined : `${link}/${set.id}#step=${stepId}`,
    };
  }

  return (
    <>
      <Progress>
        <FormattedMessage {...messages.meetingsPlanned} values={values} />
        <ProgressBar now={(100 * values.count) / values.total} />
      </Progress>
      <DropdownButton
        variant="light"
        title={title}
        align="end"
        id={`set-set-${set.id}`}
      >
        <Dropdown.Item {...getProps(1)}>
          <FormattedMessage {...messages.updateGeneral} />
        </Dropdown.Item>
        <Dropdown.Item {...getProps(2)}>
          <FormattedMessage {...messages.updateStudents} />
        </Dropdown.Item>
        <Dropdown.Item {...getProps(3)}>
          <FormattedMessage {...messages.updatePeriod} />
        </Dropdown.Item>
        <Dropdown.Item {...getProps(4)}>
          <FormattedMessage {...messages.updateAssign} />
        </Dropdown.Item>
        <Dropdown.Item {...getProps(5)}>
          <FormattedMessage {...messages.updateRegistration} />
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          eventKey="6"
          to={`${overviewLink}/${set.id}`}
        >
          <FormattedMessage {...messages.overview} />
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item as="button" eventKey="9" onClick={handleDelete}>
          <span className="text-danger"><FormattedMessage {...messages.cancel} /></span>
        </Dropdown.Item>
      </DropdownButton>
    </>
  );
}

CompleteControls.propTypes = {
  set: PropTypes.object,
  link: PropTypes.string,
  overviewLink: PropTypes.string,
  onDelete: PropTypes.func,
};

export default CompleteControls;
